import { JsonItem } from "../list-management.objects";
import { SpecialCaseEntity } from "../list-management.form-sections";
import _ from "lodash";
export class ListSelection implements SpecialCaseEntity {
    id: string;
    displayName: string;
    description: string;
    propertyName: string;
    isRequired: boolean;
    isNew: boolean;
    isNumber: boolean;

    storedValues: any[];
    initialValue: any;

    currentItemArr: string[];


    constructor(id: string, propertyName: string, displayName: string, description: string, isRequired: boolean, isNew: boolean = false, isNumber: boolean = false) {
        this.id = id;
        this.displayName = displayName;
        this.description = description;
        this.propertyName = propertyName;
        this.isRequired = isRequired;
        this.isNew = isNew;
        this.isNumber = isNumber;
    }

    generateHtml(): string {
        let size = "";
        if (this.isNew) {
            size = "col-lg-5";
        }
        let required = "";
        if (this.isRequired) required = "required";
        let inputType = "text";
        if (this.isNumber) {
            inputType = "number"
        }

        let html = `
            <div class="mb-2">
                <label class="${required}">${this.displayName}</label>
                ${this.description != "" ? `<p class='form-text mb-1 mt-0'>${this.description}</p>` : ``}
            </div>
            <div id="${this.id}-list-selection-container" class="list-selection-container mb-3 col-12 ${size} px-0">
                <div id="${this.id}-list-gallery-container" class="list-gallery-container mb-2">
                    
                </div>
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <button class="btn list-selection-btn" type="button" id="${this.id}-add-item-btn">Add +</button>
                    </div>
                    <input type="${inputType}" class="form-control" id="${this.id}-add-item-input">
                </div>
            </div>
        `
        return html;
    }

    initialize(pickLists: JsonItem[], entityArr: any[]): void {
        this.initialValue = undefined;
        this.currentItemArr = [];

        $(`#${this.id}-add-item-btn`).on("click", () => {
            let val = <string>$(`#${this.id}-add-item-input`).val();
            if (val) {
                if (this.isNumber) {
                    this.resetDisplayValid();
                    let regex: RegExp = new RegExp(/^\d+$/);
                    let isValid = regex.test(val);
                    if (!isValid) {
                        this.displayValid(false);
                        return;
                    }
                }

                this.currentItemArr.push(val);
                $(`#${this.id}-add-item-input`).val("");
                this.updateListGallery();
            }
        })
    }    

    getValue(): any {
        if (this.currentItemArr.length == 0) {
            return "";
        }
        return this.currentItemArr.join("|");
    }

    getDisplayValue(indexVal: number = -1): string {
        let useCurrent: boolean = indexVal < 0;
        let defaultDisplay = "-- Unknown --";

        if (useCurrent) {
            return this.currentItemArr.join("<br>");
        }
        else {
            let targetItem = this.storedValues[indexVal];
            if (targetItem) {
                let targetArr = targetItem.split("|");
                return targetArr.join("<br>");
            }
            else {
                return defaultDisplay;
            }
        }
    }

    validate(): boolean {
        this.resetDisplayValid();

        let isValid: boolean = true;

        if (this.isRequired) {
            if (this.currentItemArr.length == 0) {
                isValid = false;
            }
        }

        this.displayValid(isValid);

        return isValid;
    }

    displayValid(isValid: boolean): void {
        if (isValid) {
            $(`#${this.id}-add-item-input`).removeClass("is-invalid");
        }
        else {
            $(`#${this.id}-add-item-input`).addClass("is-invalid");
        }
    }

    resetDisplayValid() {
        $(`#${this.id}-add-item-input`).removeClass("is-valid").removeClass("is-invalid");
    }


    updateStoredValues(entityArray: any[]): void {
        this.storedValues = [];

        entityArray.forEach(entity => {
            this.storedValues.push(_.get(entity, this.propertyName));
        })

        // if all values match => populate value
        if (this.storedValues.every((val, i, arr) => val == arr[0]) && this.storedValues.length > 0) {
            this.populateField(this.storedValues[0]);
        }

        if (this.initialValue == undefined) {
            this.initialValue = this.getValue();
        }      
    }

    populateField(value: string): void {
        if (value) {
            let itemArr = value.split("|");
            this.currentItemArr = itemArr;
        }

        this.updateListGallery();
    }

    checkChanged(): boolean {
        if (this.getValue() != this.initialValue) {
            return true;
        }
        else {
            return false;
        }
    }

    updateListGallery(): void {
        let galleryContainer = $(`#${this.id}-list-gallery-container`);

        let content = "";
        for (let i = 0; i < this.currentItemArr.length; i++) {
            let currentItem = this.currentItemArr[i];

            let galleryItem = `
                <div class="gallery-item d-flex align-items-center justify-content-between">
                    <div class="gallery-item-text">${currentItem}</div>
                    <div class="gallery-item-delete" data-index="${i}">
                        <i class="fa-solid fa-trash fa-lg"></i>
                    </div>
                </div>
            `;

            content += galleryItem;
        }

        if (content == "") {
            content = `
                <div class="gallery-item">
                    <div class="gallery-item-text">No current ${this.displayName}</div>
                </div>
            `
        }

        galleryContainer.empty().html(content);

        galleryContainer.find(".gallery-item-delete").on("click", (e) => {
            let targetIndexStr = $(e.currentTarget).data("index");
            if (targetIndexStr != null && targetIndexStr != undefined) {
                let targetIndex: number = parseInt(targetIndexStr);
                if (targetIndex != NaN) {
                    this.currentItemArr.splice(targetIndex, 1);
                    this.updateListGallery();
                }
            }
        })

        $(`#${this.id}-add-item-input`).trigger("change");
    }
}
